<template>
  <div class="callInfoList">
    <FORM ref="childForm" @formclick="formclick" :formData="formData"></FORM>
    <table-page ref="childTable" @btnclick="bthClick" :pageData="pageData" @getTableData="getTableData"></table-page>
    <UPDATE ref="childUpdate" @submit="submit" :updateData="updateData" @uploadFile="uploadFile"></UPDATE>


      <el-dialog title="未注册用户信息导入" :visible.sync="importVisible">
        <div>
          <el-upload ref="upload" drag
                     :limit=1
                     :action="getUploadUrl()"
                     :auto-upload="false"
                     accept=".xlsx"
                     :file-list="fileList"
                     :on-change="fileChange"
                     :on-success="handleSuccess"
          >
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">
              {{ $t('im.upload.uploadTipPrefix') }}<em>{{ $t('im.upload.uploadTipSuffix') }}</em>
            </div>
            <div class="el-upload__tip" slot="tip">{{ $t('im.upload.uploadNumTip') }}</div>
          </el-upload>
        </div>
        <div>
          <a href="https://config.hteew.com/upload/model/未注册用户导入模版.xlsx"
             class="el-button el-button--success el-button--default is-plain"
          >{{ $t('im.upload.downExample') }}</a>
          <el-button size="big" type="primary" @click="uploadMobilePhoneFile">上传</el-button>
        </div>
      </el-dialog>



    <noteList v-show="noteDetailVisible" ref="noteList"></noteList>

    <el-dialog
      title="拨打电话"
      :visible.sync="callDialogVisible"
      width="30%"
      center
    >
      <el-form ref="callDirect" :rules="callRules" :model="callDirectModel" label-width="80px">
        <el-form-item label="手机号码" prop="mobilePhone">
          <el-input v-model="callDirectModel.mobilePhone"></el-input>
        </el-form-item>
        <el-form-item label="分机号" prop="extension">
          <el-input v-model="callDirectModel.extension" readonly class="font_show"></el-input>
        </el-form-item>

        <el-form-item label="线路" prop="prefixes">
          <el-select placeholder="请选择线路" v-model="callDirectModel.prefixes">
            <el-option v-for="(value,key) in prefixesArray" :label="key" :value="value"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" :disabled="isButtonDisabled"
                     @click="callMobilePhone(callDirectModel)"
          >拨打
          </el-button>
          <el-button @click="hangUpCustomerNumber(callDirectModel)">挂断</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>


    <el-drawer
      title="拨打电话服务"
      :visible.sync="drawer"
      size="60%"
      :wrapperClosable=false
    >
      <div class="drawer_left">
        <el-tabs type="border-card">
          <el-tab-pane label="备注记录列表">
            <div class="drawer_scroll">
              <el-timeline :reverse="reverse" style="padding: 30px">
                <el-timeline-item
                  v-for="(note, index) in notes"
                  :key="index"
                  :color="note.color"
                  :timestamp="note.timestamp"
                >
                  <div class="notes">
                    <div><p>备注內容：{{ note.remark }}</p></div>
                    <div><p> 分類：{{ note.connectedLabel }}</p></div>
                    <div><p> 撥打方式：{{ note.type }}</p></div>
                    <div><p>操作人：{{ note.createUser }}</p></div>
                    <div><p>线路：{{ note.prefixes }}</p></div>
                    <div>
                      <p>操作：
                        <i class="el-icon-edit" @click="onModify(note)"></i>
                        <i class="el-icon-delete" @click="onDel(note)"></i>
                      </p>
                    </div>
                  </div>
                </el-timeline-item>
              </el-timeline>
            </div>
          </el-tab-pane>
          <el-tab-pane label="客戶資料">
            <div class="drawer_scroll">
              <div class="notes">
                <div><p>会员账号：{{ info.customerNumber }}</p></div>
                <div><p>手机号码：{{ info.mobilePhone }}</p></div>
                <div><p>姓名：{{ info.name }}</p></div>
                <div><p>性別：{{ info.sex }}</p></div>
                <div><p>邮箱：{{ info.email }}</p></div>
                <div><p>注册时间：{{ info.regTime }}</p></div>
                <div><p>导入方式：{{ info.typeLabel }}</p></div>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>

      </div>
      <div class="drawer_right">
        <div class="form_info">
          <el-form ref="callForm" :rules="callRules" :model="callModel" label-width="80px">

            <el-form-item label="姓名">
              <el-input v-model="callModel.name" readonly></el-input>
            </el-form-item>
            <el-form-item label="手机号码" prop="mobilePhone">
              <el-input v-model="callModel.mobilePhone" readonly class="font_show"></el-input>
            </el-form-item>

            <el-form-item label="账号" prop="customerNumber">
              <el-input v-model="callModel.customerNumber" readonly></el-input>
            </el-form-item>

            <el-form-item label="分机号" prop="extension">
              <el-input v-model="callModel.extension" readonly></el-input>
            </el-form-item>

            <el-form-item label="线路" prop="prefixes">
              <el-select placeholder="请选择线路" v-model="callModel.prefixes" @change="changePrefix">
                <el-option v-for="(value,key) in prefixesArray" :label="key" :value="value"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item>
              <el-button type="primary" :disabled="isButtonDisabled" @click="callCustomerNumber">拨打
              </el-button>
              <el-button @click="hangUpCustomerNumber(callModel)">挂断</el-button>
            </el-form-item>
          </el-form>
        </div>
        <div class="form_info">
          <el-form ref="noteForm" :rules="noteRules" :model="noteModel" label-width="80px">
            <el-form-item label="备注ID" prop="id">
              <el-input v-model="noteModel.id" readonly></el-input>
            </el-form-item>
            <el-form-item label="账号" prop="customerNumber">
              <el-input v-model="noteModel.customerNumber" readonly></el-input>
            </el-form-item>
            <el-form-item label="手机号码" prop="mobilePhone">
              <el-input v-model="noteModel.mobilePhone" readonly></el-input>
            </el-form-item>
            <el-form-item label="线路" prop="prefixes" hidden="true">
              <el-input v-model="noteModel.prefixes"></el-input>
            </el-form-item>

            <el-form-item label="分类" prop="connected">
              <el-select v-model="noteModel.connected" placeholder="请选择" @change="connectedChange">
                <el-option
                  v-for="item in connectedArray"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="备注" prop="remark">
              <textarea class="textArea" type="textarea" v-model="noteModel.remark" required></textarea>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="onModifySave('noteForm')">提交</el-button>
              <el-button @click="clearAll">重置</el-button>
            </el-form-item>
          </el-form>
        </div>
        <div style="float: right;padding-right: 5%">
          <el-button-group>
            <el-button type="primary" icon="el-icon-arrow-left" @click="before">上一位</el-button>
            <el-button type="primary" @click="next">下一位<i class="el-icon-arrow-right el-icon--right"></i></el-button>
          </el-button-group>
        </div>
      </div>
    </el-drawer>

  </div>
</template>

<script>
import Url from '@/views/analyse/util/url'
import FORM from '@/components/page/form'
import tablePage from '@/components/page/table'
import download from '@/utils/download'
import Qs from 'qs'
import axios from '@/utils/request'
import URL from '@/views/mis/util/url'
import UPDATE from '@/components/page/update'
import DateUtil from '@/utils/IM/tradeDataUtil'
import Specials from '@/views/crs36/cfinr/luckyDraw/specials'
import importInfo from '@/views/analyse/sleeping/importInfo'
import noteList from '@/views/analyse/sleeping/noteList'
import originAxios from 'axios'
import { getToken } from '@/utils/auth'
import { getQueryString } from '@/utils/tools'
import { MessageBox } from 'element-ui'

require('@/views/analyse/sleeping/notedetail.css')

let callTypeArray = { 0: '模拟账号拨打', 1: '真实账号拨打', 2: '手机拨打' }
let connectedList = [{ value: 0, label: '有效沟通' }, { value: 1, label: '没有接通' }, {
  value: 2,
  label: '接通挂线'
}, { value: 3, label: '用户正忙' }, { value: 4, label: '空号停机' }, { value: 5, label: '明确表示无意向' }, {
  value: 6,
  label: '其他无效沟通'
}, { value: 7, label: '异常客户' }, { value: 8, label: '不便接聽' }, { value: 9, label: '非本人注册' }, {
  value: 10,
  label: '無需跟進'
}]
let connectedArray = {
  0: '有效沟通',
  1: '没有接通',
  2: '接通挂线',
  3: '用户正忙',
  4: '空号停机',
  5: '明确表示无意向',
  6: '其他无效沟通',
  7: '异常客户',
  8: '不便接聽',
  9: '非本人注册',
  10: '無需跟進'
}
let types = { 2: '手机号码导入', 0: '模拟账号导入' }
const CUSTOMER_NUMBER_REGEX = /^\d{8}$/;
const PHONE_NUMBER_REGEX = /^1[3-9]\d{9}$/;

function getConnectedLabel(connected) {
  for (const coon in connectedList) {
    if (coon == connected) return connectedList[coon].label
  }
}

function getCallType(type) {
  for (const coon in callTypeArray) {
    if (coon == type) return callTypeArray[coon]
  }
}

function validateImport(model) {
    let { manuallyInput, ...validatedPayload } = model;
    let invalidCustomerNumbers = [];
    let invalidPhoneNumbers = [];
    if(manuallyInput) {
      let inputs = manuallyInput.split(',');
      if(inputs.length > 0) {
        if(inputs.length > 3) {
          MessageBox.alert('超过输入限制：'+inputs.length+' > 3','参数检查'); 
          return undefined;
        }
        inputs.forEach(input => {
          if(model.type == 0) { //客户账号
            if(!CUSTOMER_NUMBER_REGEX.test(input.trim())) {
              invalidCustomerNumbers.push(input.trim());
            }
          } else if (model.type == 2) { //客户手机
            if(!PHONE_NUMBER_REGEX.test(input.trim())) {
              invalidPhoneNumbers.push(input.trim());
            }
          }
        }) 
        console.log('cn',invalidCustomerNumbers,' pn',invalidPhoneNumbers);
        if(invalidCustomerNumbers && invalidCustomerNumbers.length > 0) {
          MessageBox.alert('无效账号：'+invalidCustomerNumbers.join(','),'参数检查', {callback: () => {invalidCustomerNumbers = []}}); 
          return undefined;
        } 
        if(invalidPhoneNumbers && invalidPhoneNumbers.length > 0) {
          MessageBox.alert('无效的11位手机号码：'+invalidPhoneNumbers.join(','),'参数检查', {callback: () => {invalidPhoneNumbers = []}});
          return undefined;
        } 
        if(validatedPayload.customerNumbers) {
          validatedPayload.customerNumbers = validatedPayload.customerNumbers + ',' + inputs.join(',');
        } else {
          validatedPayload.customerNumbers = inputs.join(',');
        }
      }
    } 
    return validatedPayload;
  }

export default {
  name: 'callInfoList',
  components: {
    Specials,
    FORM,
    tablePage,
    UPDATE,
    noteList
  },

  data() {

    return {
      noteRules: {
        customerNumber: [
          { required: true, message: '账号不能为空', trigger: 'blur' }
        ], connected: [
          { required: true, message: '请选择接听情況', trigger: 'change' }
        ], prefixes: [
          { required: true, message: '线路不能为空', trigger: 'blur' }
        ]
      },
      callRules: {
        extension: [{ required: true, message: '分机号不能为空', trigger: 'blur' }],
        prefixes: [{ required: true, message: '线路不能为空', trigger: 'change' }], customerNumber: [
          { required: true, message: '账号不能为空', trigger: 'blur' }
        ], mobilePhone: [
          { required: true, message: '手機號不能为空', trigger: 'blur' }
        ]
      },
      isButtonDisabled: false,
      drawer: false,
      innerDrawer: false,
      importInfo: {},
      prefixesArray: [],
      fileList: [],
      noteDetailVisible: false,
      connectedArray: connectedList,
      noteModel: {},
      callModel: {},
      callDirectModel: {},
      callDialogVisible: false,
      reverse: true,
      importVisible: false,
      notes: [],
      queryData: {},
      tableData: [],
      info: {},
      updateData: {
        cols: [
          {
            title: '用戶列表',
            field: 'customerNumbers',
            type: 11,
            action: Url.utils.uploadFile,
            downUrl: 'https://config.hteew.com/upload/model/沉睡客户模版.xlsx'
          },
          { title: '少量导入', field: 'manuallyInput', type: 1, placeholder: "请输入客户账号或客户手机(最多三个,以','分割)"},
          { title: '导入类型', field: 'type', type: 2, optionList: types }
        ]
      },

      /*from查询表单*/
      formData: {
        hasLable: true,
        cols: [
          { title: '账号', field: 'customerNumber' },
          { title: '拨打备注', field: 'noteRemark' },
          { title: '分类', field: 'connected', type: 2, optionList: connectedArray },
          { title: '手机号', field: 'mobilePhone' },
          {
            title: '备注时间',
            field: 'time',
            type: 6,
            format: 'yyyy/MM/dd',
            startEndParam: ['startTime', 'endTime']
          },
          { click: window.$t('common.search') },
          { click: '导入', auth: 'analyse:importInfo:import' },
          { click: '未注册用户信息导入', auth: 'analyse:importInfo:mobilePhoneImport' },
          { click: window.$t('common.export'), auth: 'analyse:importInfo:export' },
          { click: '直接拨打', auth: 'analyse:importInfo:callDirect' }
        ]
      },
      /*table生成*/
      pageData: {
        queryUrl: Url.sleeping.importInfoList,
        selection: false,
        sequence: false,
        method: 'get',
        cols: [
          {
            title: window.$t('common.operation'),
            myFixed: 'left',
            btnClick: [
              {
                name: '拨打电话',
                click: 'callPhone',
                type: 'primary',
                icon: 'el-icon-editRebate',
                auth: 'analyse:callInfo:call'
              }
            ]
          },
          { field: 'infoId', title: 'ID' },
          { field: 'customerNumber', title: '会员账号' },
          { field: 'mobilePhone', title: '手机号码' },
          { field: 'name', title: '姓名' },
          { field: 'sex', title: '性別' },
          { field: 'email', title: '邮箱' },
          { field: 'regTime', title: '注册时间' },
          { field: 'createTime', title: '导入时间' },
          { field: 'createUser', title: '导入人' },
          {
            field: 'type', title: '导入方式', render(data, full) {
              return types[data]
            }
          },
          {
            field: 'infoTotal', title: '拨打备注', h5Click: 'details'
          },
          {
            title: window.$t('common.operation'),
            btnClick: [
              {
                name: '刪除',
                click: 'importInfoDel',
                type: 'primary',
                icon: 'el-icon-editRebate',
                auth: 'analyse:importInfo:del'
              }
            ]
          }
        ]
      },
      totalNum: {}
    }
  },
  methods: {
    getUploadUrl(){
      return  Url.sleeping.importMobilePhone;
    },// 文件状态改变时的钩子
    fileChange(file, fileList) {
      this.fileList=[]
      this.fileList.push(file.raw)
    }, handleSuccess(res, file, fileList) {
      this.fileList = []
      this.$message.success(window.$t('im.upload.success') + '')
    },
    uploadMobilePhoneFile(){
      console.info(this.fileList)
      if (this.fileList.length === 0) {
        this.$message.warning(window.$t('im.upload.pleaseUpload') + '')
      } else {
        let form = new FormData()
        let fileObj = this.fileList[0]
        form.append('file', fileObj)
        originAxios.post(Url.sleeping.importMobilePhone, form, {
          headers: {
            'Authorization': getToken(getQueryString('label')),
            'Content-Type': 'multipart/form-data'
          },
          timeout: 30000
        }).then(
          res => {
            if (res.data.code == 0) {
              this.$message.success(res.data.result)
              this.$refs.childTable.defaultGetData(this.queryData)
            } else {
              this.$message.error(res.data.message)
            }
          }, err => {
            this.$message.error('上傳失敗')
          })
      }
    },
    connectedChange() {
      this.$forceUpdate()
    },
    changePrefix() {
      this.$set(this.noteModel, 'prefixes', this.callModel.prefixes)
    },
    dataChange(url, option, suc, fail) {
      this.$axios.post(url, Qs.stringify(option || {})).then(res => {
        if (suc && (typeof suc == 'function')) suc(res)
      }).catch(res => {
        if (fail && (typeof fail == 'function')) fail(res)
      })
    }, uploadFile(col, result) {
      col.data = (result || []).join(',')
    }, bthClick(clickName, row) {
      if ('callPhone' == clickName) {
        this.callPone(row)
      } else if (clickName == 'details') {
        this.openNoteDetail(row)
      } else if ('importInfoDel' == clickName) {
        this.importInfoDel(row)
      }
    }, openNoteDetail(row) {
      this.detailsVisible = true
      this.$nextTick(() => {
        let data = this.queryData
        data.mdId = row.mdId
        this.$refs.noteList.init(data)
      })
    },

    submit(model) {
      let payload = validateImport(model);
      if(payload) {
        this.dataChange(Url.sleeping.importInfoImport, payload, res => {
          if (res.code == 0) {
            this.$refs.childUpdate.close()
            this.$message.success(res.message)
            this.$refs.childTable.defaultQueryData(this.queryData)
          } else {
            this.$message.error(res.message)
          }
        })
      }
    }, 
    
    prefixesSubmit(model) {
      this.dataChange(Url.sleeping.setPrefixes, model, res => {
        if (res.code == 0) {
          this.$refs.prefixesUpdate.close()
          this.$message.success(res.message)
        } else {
          this.$message.error(res.message)
        }
      })
    },
    /*查询表单按钮点击事件*/
    formclick(clickName, data) {
      if (window.$t('common.search') == clickName || '查询' == clickName) {
        this.formatDate(data)
        this.queryData = data
        this.$refs.childTable.defaultQueryData(data)
      } else if ('导出' == clickName || window.$t('common.export') == clickName) {
        this.formatDate(data)
        download.exportExcel(Url.sleeping.importInfoDown, data, '(模拟账号|手机)拨打')
      } else if ('导入' == clickName) {
        this.$refs.childUpdate.open()
      } else if ('直接拨打' == clickName) {
        this.callDialogVisible = true
      } else if ('未注册用户信息导入' == clickName) {
        this.fileList = []
        this.importVisible = true
      }
    },
    onModifySave(formName) {
      this.setFromImportInfo(this.noteModel)
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.dataChange(Url.sleeping.noteSave, this.noteModel, res => {
            if (res.code == 0) {
              this.initNotes()
              this.$message.success(res.message)
            } else {
              this.$message.error(res.message)
            }
          })
        } else {
          return false
        }
      })

    }, clearAll() {
      // 重置数据逻辑
      this.noteModel = {};
      this.setFromImportInfo(this.noteModel)
      this.noteModel.prefixes = this.callModel.prefixes;
      // 使用 nextTick 确保 DOM 更新完成
      this.$nextTick(() => {
        const formRef = this.$refs.noteForm; // 直接访问，不使用数组语法
        
        if (formRef) {
          formRef.clearValidate(['connected', 'prefixes']);
        } else {
          console.warn("表单引用不存在");
        }
      });
    }, initNotes() {
      if (!this.importInfo.mdId) return
      this.dataChange(Url.sleeping.getNoteInfo, this.importInfo, res => {
        if (res.code == 0) {
          this.notes = this.parseResult(res.result.list)
        } else {
          this.$message.error(res.message)
        }
      })
    }, parseResult(list) {
      var notes = []
      if (list !== null) {
        list.forEach(elem => {
          notes.push({
            timestamp: DateUtil.formatDate(elem.createTime, 'yyyy-MM-dd hh:mm:ss'),
            remark: elem.remark,
            createUser: elem.createUser,
            id: elem.id,
            connected: elem.connected,
            color: '#0bbd87',
            connectedLabel: getConnectedLabel(elem.connected),
            type: getCallType(elem.type),
            prefixes: elem.prefixes

          })
        })
        notes.reverse()
      }
      return notes
    },
    onModify(data) {
      this.noteModel = {}
      this.initModifyNote(data)
    }, initModifyNote(data) {
      this.noteModel.remark = data.remark
      this.noteModel.id = data.id
      this.noteModel.mdId = data.mdId
      this.noteModel.connected = data.connected
      this.$set(this.noteModel, 'prefixes', data.prefixes)
      this.setFromImportInfo(this.noteModel)
    }, onDel(data) {
      this.setFromImportInfo(data)
      this.confirmJob(Url.sleeping.noteDel, data)
    },
    setFromImportInfo(data) {
      data.customerNumber = this.importInfo.customerNumber
      data.mobilePhone = this.importInfo.mobilePhone
      data.mdId = this.importInfo.mdId
      data.type = this.importInfo.type
      data.name = this.importInfo.name
      data.sex = this.importInfo.sex
    },
    callPone(data) {
      // console.log('Current customer:', data);
      if (!data.mdId || data.mdId === null) {
        this.$notify.error({
          title: '警告',
          message: '手机号码不能为空',
          type: 'warning'
        })
        return
      }
      this.drawer = true
      this.initInfo(data)
      this.initImportInfo(data)
      this.initNoteModel()
      this.initCallModel()
      this.initNotes()
    },
    initInfo(data){
      this.info = data
      this.info.typeLabel=types[data.type]
    },
    initImportInfo(data) {
      this.importInfo.type = data.type
      this.importInfo.customerNumber = data.customerNumber
      this.importInfo.mobilePhone = data.mobilePhone
      this.importInfo.mdId = data.mdId
      this.importInfo.name = data.name
      this.importInfo.sex = data.sex
    },
    initNoteModel() {
      // this.setFromImportInfo(this.noteModel)
      this.clearAll();
    },
    initCallModel() {
      this.setFromImportInfo(this.callModel)
    },
    initPrefixes() {
      this.dataChange(Url.sleeping.getPrefixes, {}, res => {
        if (res.code == 0) {
          this.prefixesArray = res.result.prefixes
          this.callModel.extension = res.result.extension
          this.callDirectModel.extension = res.result.extension
        }
      })
    },
    parseJson(data, callback) {
      var notes = []
      if (data !== null) {
        let jsonData = JSON.parse(data)
        for (let key in jsonData) {
          if (jsonData.hasOwnProperty(key)) {
            notes.push(callback(jsonData[key], key))
          }
        }
      }
      return notes
    },
    handleClose(done) {
      this.$confirm('确定关闭吗？')
        .then(_ => {
          this.noteModel = {}
          this.hangUpCustomerNumber(this.callModel)
          this.$refs.childTable.defaultQueryData(this.queryData)
          done()
        })
        .catch(_ => {
        })
    }, confirmJob(url, data) {
      this.$confirm('此操作将永久删除该記錄, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.dataChange(url, data, res => {
          this.initNotes()
          this.$message({
            type: 'success',
            message: '删除成功!'
          })
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    callAjax(formName, model) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.dataChange(Url.sleeping.call, model, res => {
            if (res.code == 0) {
              this.isButtonDisabled = true
            } else {
              this.$message.error(res.message)
            }
          })
        } else {
          return false
        }
      })
    }, callMobilePhone() {
      this.callDirectModel.type = 2
      this.callAjax('callDirect', this.callDirectModel)
    },
    callCustomerNumber() {
      this.setFromImportInfo(this.callModel)
      this.callAjax('callForm', this.callModel)
    },
    hangUpCustomerNumber(model) {
      this.setFromImportInfo(model)
      this.dataChange(Url.sleeping.hangup, model, res => {
        if (res.code == 0) {
          this.$message.success(res.message)
          this.isButtonDisabled = false
        } else {
          this.$message.error(res.message)
        }
      })
    }, importInfoDel(row) {
      this.$confirm('此操作将永久删除该記錄, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.dataChange(Url.sleeping.importInfoDel, { id: row.infoId }, res => {
          this.$message.success(res.message)
          this.$refs.childTable.defaultQueryData(this.queryData)
          this.$message({
            type: 'success',
            message: '删除成功!'
          })
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    formatDate(data) {
      data.startTime = data.startTime ? new Date(data.startTime).getTime() : ''
      data.endTime = data.endTime ? new Date(data.endTime).getTime() : ''
    }, getTableData(tableData) {
      this.tableData = tableData
    },
    next() {
      let index = this.getIndex()
      if (index !== -1 && index < this.tableData.length - 1) { // 確保不是最後一個元素
        let nextElement = this.tableData[index + 1] // 獲取下一位元素
        this.callPone(nextElement)
      } else {
        this.message('后面已經沒有數據了')
      }
    }, before() {
      let index = this.getIndex()
      if (index > 0) { // 確保不是最後一個元素
        let nextElement = this.tableData[index - 1] // 獲取下一位元素
        this.callPone(nextElement)
      } else {
        this.message('前面已經沒有數據了')
      }
    }, getIndex() {
      return this.tableData.findIndex(item => this.compareCustomer(item))
    },
    compareCustomer(item) {
      if (this.importInfo.type == 0) {
        return item.customerNumber == this.importInfo.customerNumber
      } else if (this.importInfo.type == 2) {
        return item.mobilePhone == this.importInfo.mobilePhone
      }
    },
    message(info) {
      this.$notify({
        title: '警告',
        message: info,
        type: 'warning'
      })
    }
  },
  mounted() {
    this.initPrefixes()
  }

}

</script>
